import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AuthState = {
  isAuth: boolean;
  username: string;
  email: string;
  phoneNumber: string;
  name: string;
  image: string;
  accessToken: string;
};

const initialState: AuthState = {
  isAuth: false,
  username: '',
  name: '',
  image: '',
  email: '',
  phoneNumber: '',
  accessToken: ''
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<Partial<AuthState>>) => ({
      ...state,
      isAuth: true,
      ...action.payload
    }),
    resetAuth: () => initialState
  }
});

export const authReducer = authSlice.reducer;
export const authActions = {
  ...authSlice.actions
};
